// The booking widget quotes a price before the customer types a flight number. The quote sends
// the flight field as the customer typed it. An empty field goes as empty, and the server quotes
// it as a non-eligible flight (ShareDiscountService), so a typed TUI flight can only improve the
// price. A typed value goes to the server as typed, even when it is incomplete, so every keystroke
// re-quotes on what the customer has named so far. The server trims the spaces itself.
//
// The placeholder of the flight number inputs is an example TUI flight number. The quote never
// sends it. The widget refuses it at "next step" when the customer typed it by hand; the server
// has no such rule.
//
// The decision lives here, outside the React component, so that `node --test` covers it. The
// file is .mjs so that `node --test` loads it as an ES module; Vite resolves the extension-less
// import.
const FLIGHT_NUMBER_PLACEHOLDER = 'TB0000';

function flightNumberForQuote(flightNumber) {
    if (flightNumber === undefined || flightNumber === null) {
        return '';
    }

    return flightNumber;
}

export { FLIGHT_NUMBER_PLACEHOLDER, flightNumberForQuote };
